import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { resolveMnemonicGateState } from "@-/dev.improve.haniverse.lib.morpheme.mnemonic-gate";

/**
 * Whether this grapheme has no mnemonic at all — neither one the viewer wrote nor one in the
 * catalog. This is the only state that offers the "Add Mnemonic" affordance, and it is
 * gate-independent: `absent` is decided before any premium/sign-in input.
 */
export function useHasAbsentMnemonic(): boolean {
  const [mnemonicFromCatalog, mnemonicFromActor] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.mnemonic?.trim() ?? "",
    (c) => c.userSlice.data.meaningCard?.description?.trim() ?? "",
  );

  return (
    resolveMnemonicGateState({
      hasCatalogMnemonic: mnemonicFromCatalog.length > 0,
      hasOwnMnemonic: mnemonicFromActor.length > 0,
      hasRevealed: false,
      isDescriptionPremium: false,
      isPremium: false,
      isReferenceSurface: false,
      isSignedIn: false,
    }) === "absent"
  );
}
